var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.515 209.532C114.829 212.611 91.7207 207.171 73.2754 194.409C54.83 181.646 42.5581 162.607 39.1593 141.479L47.7134 140.318C50.7723 159.333 61.8171 176.469 78.4179 187.955C95.0187 199.441 115.816 204.337 136.234 201.566L137.515 209.532Z",
    fill: "url(#paint0_linear_141_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.903 239.81C105.889 242.858 76.8522 234.255 54.1812 215.894C31.5101 197.532 17.0615 170.917 14.014 141.903L24.9538 140.754C27.6966 166.867 40.7003 190.82 61.1043 207.345C81.5082 223.87 107.641 231.613 133.754 228.871L134.903 239.81Z",
    fill: "url(#paint1_linear_141_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.687 211.783C160.992 219.624 145.635 224.112 129.873 224.881C114.11 225.65 98.3899 222.678 83.9965 216.207C69.6031 209.736 56.9455 199.951 47.0585 187.651C37.1716 175.351 30.336 160.886 27.1108 145.438L36.8997 143.394C39.8024 157.297 45.9544 170.316 54.8527 181.386C63.7509 192.456 75.1428 201.263 88.0969 207.086C101.051 212.91 115.199 215.585 129.385 214.893C143.572 214.201 157.392 210.161 169.718 203.104L174.687 211.783Z",
    fill: "url(#paint2_linear_141_3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 125,
    r: 20,
    stroke: "#80E614",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.485 40.4678C135.171 37.3887 158.279 42.8288 176.725 55.5913C195.17 68.3538 207.442 87.3933 210.841 108.521L202.287 109.682C199.228 90.6671 188.183 73.5315 171.582 62.0453C154.981 50.559 134.184 45.6629 113.766 48.4341L112.485 40.4678Z",
    fill: "url(#paint3_linear_141_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.097 10.1897C144.111 7.14217 173.148 15.7453 195.819 34.1065C218.49 52.4677 232.938 79.083 235.986 108.097L225.046 109.246C222.303 83.1335 209.3 59.1797 188.896 42.6547C168.492 26.1296 142.359 18.3867 116.246 21.1295L115.097 10.1897Z",
    fill: "url(#paint4_linear_141_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3133 38.2174C89.0085 30.3763 104.365 25.8878 120.127 25.1188C135.89 24.3499 151.61 27.3223 166.004 33.7931C180.397 40.2638 193.055 50.0493 202.942 62.3492C212.828 74.6492 219.664 89.1145 222.889 104.562L213.1 106.606C210.198 92.7031 204.046 79.6843 195.147 68.6143C186.249 57.5443 174.857 48.7375 161.903 42.9138C148.949 37.0901 134.801 34.4149 120.615 35.107C106.429 35.799 92.6076 39.8387 80.282 46.8957L75.3133 38.2174Z",
    fill: "url(#paint5_linear_141_3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 125,
    r: 20,
    transform: "rotate(-180 220 125)",
    stroke: "#80E614",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_141_3",
    x1: 38.2335,
    y1: 127.469,
    x2: 156.5,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#B0C39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80E614",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_141_3",
    x1: 13.6807,
    y1: 122.732,
    x2: 164.576,
    y2: 197.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#B0C39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80E614",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_141_3",
    x1: 45.8852,
    y1: 63.8376,
    x2: 204.115,
    y2: 186.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807322,
    stopColor: "#80E614",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80E614",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_141_3",
    x1: 211.766,
    y1: 122.531,
    x2: 93.5,
    y2: 66.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#B0C39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80E614",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_141_3",
    x1: 236.319,
    y1: 127.269,
    x2: 85.4243,
    y2: 52.1332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0C49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#B0C39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80E614",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_141_3",
    x1: 204.115,
    y1: 186.162,
    x2: 45.8852,
    y2: 63.8376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807322,
    stopColor: "#80E614",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80E614",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.9b76fd6f7e4f02e8f09a3932959877ff.svg";
export { ForwardRef as ReactComponent };